import { Transaction } from "./Transaction";
import { CashTransaction } from "./CashTrasanction";
import { TransactionType, TransFields } from "../shared/Consts"
import { Price } from "./Price";
import Portfolio from "./Portfolio";
import Utils from "../portlibs/PortUtils";
import axios from "axios"
import GICHolding from "./GICHolding";
import Prices from "./Prices";
import IPortfolio from "../shared/IPortfolio";
import Holding from "./Holding";
import * as _ from "lodash"
import { ITransRow } from "../shared/ITransaction";
import JWTApi, { type IUser } from "../libs/login/JWTApi";

export interface IAccount {
    id:number;
    name:string;
}
export enum AccountTypes {
    cash = 0,
    rrsp = 1,
    tfsa = 2
}
export default class PortAccount extends JWTApi {
    static i = new PortAccount();

    private _sak:string|null = null;
    private _portfolio:Portfolio = new Portfolio()
    private _json:IPortfolio|undefined

    get headers(){return {headers:{sak:this._sak!,"content-type":"application/json"}}}
    get portfolio(){return this._portfolio}

    constructor(){
        super();
        super.setMaxListeners(100);
        (window as any).account = this;
    }

    ////////////////////////////////////////////////////////////////////////////
    // auth
    async me(){ return this._setPortfolio(await this.api.get<IPortfolio>("/1/users/me").then(data => data.data)) }

    ////////////////////////////////////////////////////////////////////////////
    // old
    async transferAccount(from:number, to:number){
        const transactions:Transaction[] = [
            ...this.portfolio.cash(0, from).transactions,
            ...this.portfolio.cash(1, from).transactions
        ]
        for(const holding of this.portfolio.holdings){
            for(const trans of holding.transactions){
                if (trans.accountId==from) {
                    transactions.push(trans)
                }
            }
        }
        const postfix = `Xfer ${Utils.formatDate('yyyy-MM-dd', new Date())}`
        for(const trans of transactions){
            const t = trans.clone()
            t.accountId = to
            t.note = t.note + (t.note ? " " : "") + postfix
            await this._updateTransaction(trans.holding, trans.clone())
        }
    }
    async _setPortfolio(portfolio: IPortfolio){
        await Prices.i.load(Object.keys(portfolio.holdings))
        this._portfolio = new Portfolio(portfolio)
        this._json = portfolio
        this.emit("refresh", this._portfolio)
        return this._portfolio
    }

    get authenticated(){ return this._sak ? true : false }
    
    async addAccount(name:string,type:string) {
        const {data:portfolio} = await this.api.put("/1/users/me/accounts/" + type, JSON.stringify(name), this.headers)
        return this._setPortfolio(portfolio)
    }
    async updateAccount(id:number,name:string,type:number,hide:boolean){
        await this.api.post("/1/users/me/accounts", {[id]:{name,type,hide}}, this.headers)
    }
    async update(portfolio:Portfolio, trans:Transaction, updateCash:boolean, withholdingTax?:boolean){
        let data = await this._update(trans)
        if (updateCash && !trans.holding.isCash) await this.updateCash(portfolio, trans)
        if (withholdingTax) await this.tax(portfolio, trans)
        return data
    }
    async switchTicker(old:Transaction, ticker:string) {
        ticker = ticker.toUpperCase()
        if (old.holding.isCashEq) {
            const trans = (old.holding as GICHolding).gicTransactions
            for(const t of trans){
                const n = t.clone(true)
                await this._update(n, ticker)
            }
            for(let i=trans.length-1; i>=0; i--) {
                await this.deleteTrans(trans[i])
            }
        }else{
            const n = old.clone(true)
            await this._update(n, ticker)
            await this.deleteTrans(old)
        }
    }
    async updateTicker(old:string, ticker:string){
        const holding = this.portfolio.holding(old)
        if (!holding) return

        const transactions = holding.transactions.slice(0)
        for(const trans of transactions) {
            await this.switchTicker(trans, ticker)
        }
    }
    async deleteTrans(trans:Transaction){
        if (!this._json) throw {status:401,msg:"Not authorized"}
        await this.api.delete(`/1/users/me/holdings/${trans.holding.id}/${trans._id}`, this.headers)
        _.remove(this._json.holdings[trans.holding.id], t => t._id==trans._id)
        return this._setPortfolio(this._json)
    }
    async tax(portfolio:Portfolio, trans:Transaction) {
        const cashTrans = new CashTransaction(portfolio!.cash(1), {
            [TransFields.date] : Utils.formatDate("yyyy-MM-dd", trans.date),
            [TransFields.type] : TransactionType.adjust,
            [TransFields.quantity] : -trans.quantity*0.15,
            [TransFields.price] : 1,
            [TransFields.note] : trans.holding.id + " Tax",
            [TransFields.account] : trans.accountId
        })
        return this._update(cashTrans)
    }
    async updateCash(portfolio:Portfolio, trans:Transaction){
        const cash = portfolio!.cash(trans.holding.currency)
        let cashNote = trans.holding.id;
        let qty = 0;
        if (trans.isBuy||trans.isSell) {
            qty -= trans.quantity*trans.price
            cashNote += " " + (trans.quantity>0 ? "Buy":"Sell")
        }
        else if (trans.isReinvest) {
            qty -= trans.quantity*trans.price
            cashNote += " Reinvest";
        }
        else {
            if (trans.isDividend) cashNote += " Dividend";
            qty = trans.quantity*trans.price
        }
        const cashTrans = new CashTransaction(cash, {
            [TransFields.date] : Utils.formatDate("yyyy-MM-dd", trans.date),
            [TransFields.type] : TransactionType.adjust,
            [TransFields.quantity] : qty,
            [TransFields.price] : 1,
            [TransFields.note] : cashNote,
            [TransFields.account] : trans.accountId
        })
        return this._update(cashTrans)
    }
    async updatePrice(price:Price){
        await this.api.post(`/1/prices/${price.id}`, price.payload, this.headers)
        Prices.i.update(price)
        this._setPortfolio(this._portfolio.json)
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // helpers
    private async _update(trans:Transaction, ticker?:string) {
        if (!this._json) throw {status:401,msg:"not authorized"}
        if (!ticker) ticker = trans.holding.id
        const _trans = (trans._id ? 
            await this.api.post<ITransRow>(`1/users/me/holdings/${ticker}/${trans._id}`, trans.payload, this.headers) : 
            await this.api.post<ITransRow>(`/1/users/me/holdings/${ticker}`, trans.payload, this.headers)).data
        
        return this._updateTransaction(trans.holding, _trans)
    }
    private async _updateTransaction(holding:Holding, _trans:ITransRow){
        const ticker = holding.id
        const holdings = this._json!.holdings

        if (ticker in holdings) {}
        else holdings[ticker] = []
        
        const index = _.findIndex(holdings[ticker], t => t._id==_trans._id)
        if (index>=0) holdings[ticker][index] = _trans
        else holdings[ticker].push(_trans)

        return {
            portfolio: await this._setPortfolio(this._json!),
            transaction:_trans
        }
    }
}
